import styled from '@emotion/styled';

// Layout pieces shared by the Analytics, Sessions, Profit, Limits, Feedback
// and Passkeys pages (same look as Reconciliation's).

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
`;

export const Card = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
  padding: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;

export const CardHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-family: var(--font-body);
  letter-spacing: -0.01em;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.HetheraBlack};
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

// A row of pill buttons: tabs, segment pickers, "chart / table".
export const Segmented = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 3px;
  border-radius: 10px;
  background: var(--sunk);

  & > button {
    border: 0;
    background: transparent;
    padding: 5px 12px;
    border-radius: 8px;
    font-weight: 500;
    font: inherit;
    font-size: 13px;
    color: ${({ theme }) => theme.palette.grayTextColor};
    cursor: pointer;
  }

  & > button.active {
    background: white;
    color: ${({ theme }) => theme.palette.HetheraBlack};
    font-weight: 600;
    box-shadow: 0 1px 2px rgba(14, 26, 19, 0.1);
  }

  & > button:not(.active):hover {
    color: ${({ theme }) => theme.palette.HetheraBlack};
  }
`;

export const Select = styled.select`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 10px;
  padding: 8px 12px;
  font: inherit;
  font-size: 14px;
  background: white;
`;

export const Input = styled.input`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 10px;
  padding: 8px 12px;
  font: inherit;
  font-size: 14px;
  background: white;
  min-width: 0;
`;

export const SimpleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th {
    text-align: left;
    font-weight: 500;
    font-size: 12.5px;
    color: ${({ theme }) => theme.palette.grayTextColor};
    background: var(--panel);
    padding: 10px 12px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
    white-space: nowrap;
  }

  td {
    padding: 11px 12px;
    border-bottom: 1px solid #efece4;
    vertical-align: top;
  }

  tbody tr:hover td {
    background: var(--panel);
  }

  td.num,
  th.num {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }

  tr.loss td {
    background: #fdf3f2;
  }
`;

export const Scroll = styled.div`
  overflow-x: auto;
  margin: 0 -8px;
  padding: 0 8px;
`;

export const Money = styled.span`
  font-variant-numeric: tabular-nums;

  &.loss {
    color: ${({ theme }) => theme.palette.errorRed};
  }
  &.gain {
    color: ${({ theme }) => theme.palette.greenColor};
  }
`;
